import { setSearchRoute } from '../history';

export function applySavedSearchRoute(data, { entity, ...options } = {}) {
  setSearchRoute(data || {}, {
    ...options,
    isProducts: entity === 'products',
  });
}
